var _style, _style2, _g, _span, _span2, _span3, _span4, _span5, _span6, _span7, _span8, _span9, _rect, _span10, _rect2, _span11, _rect3, _span12, _rect4, _span13, _rect5, _span14, _rect6, _span15, _rect7, _span16, _rect8, _span17, _rect9, _span18, _rect10, _span19, _defs, _defs2, _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhase9ConversationFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-roledescription": "flowchart-v2",
    role: "graphics-document document",
    viewBox: "0 0 248 1042",
    style: {
      maxWidth: 248,
      background: "rgb(23, 23, 25)"
    },
    className: "flowchart",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    id: "export-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "@import url(\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css\"); p {margin: 0;}")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", null, "#export-svg{font-family:arial,sans-serif;font-size:14px;fill:#ccc;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#export-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#export-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#export-svg .error-icon{fill:hsl(20, 1.5873015873%, 12.3529411765%);}#export-svg .error-text{fill:rgb(222.9999999999, 223.6666666666, 223.9999999999);stroke:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .edge-thickness-normal{stroke-width:1px;}#export-svg .edge-thickness-thick{stroke-width:3.5px;}#export-svg .edge-pattern-solid{stroke-dasharray:0;}#export-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#export-svg .edge-pattern-dashed{stroke-dasharray:3;}#export-svg .edge-pattern-dotted{stroke-dasharray:2;}#export-svg .marker{fill:#cccccc;stroke:#cccccc;}#export-svg .marker.cross{stroke:#cccccc;}#export-svg svg{font-family:arial,sans-serif;font-size:14px;}#export-svg p{margin:0;}#export-svg .label{font-family:arial,sans-serif;color:#e0dfdf;}#export-svg .cluster-label text{fill:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .cluster-label span{color:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .cluster-label span p{background-color:transparent;}#export-svg .label text,#export-svg span{fill:#e0dfdf;color:#e0dfdf;}#export-svg .node rect,#export-svg .node circle,#export-svg .node ellipse,#export-svg .node polygon,#export-svg .node path{fill:#2a2020;stroke:#ccc;stroke-width:1px;}#export-svg .rough-node .label text,#export-svg .node .label text,#export-svg .image-shape .label,#export-svg .icon-shape .label{text-anchor:middle;}#export-svg .node .katex path{fill:#000;stroke:#000;stroke-width:1px;}#export-svg .rough-node .label,#export-svg .node .label,#export-svg .image-shape .label,#export-svg .icon-shape .label{text-align:center;}#export-svg .node.clickable{cursor:pointer;}#export-svg .root .anchor path{fill:#cccccc!important;stroke-width:0;stroke:#cccccc;}#export-svg .arrowheadPath{fill:#cccccc;}#export-svg .edgePath .path{stroke:#cccccc;stroke-width:1px;}#export-svg .flowchart-link{stroke:#cccccc;fill:none;}#export-svg .edgeLabel{background-color:hsl(180, 1.5873015873%, 28.3529411765%);text-align:center;}#export-svg .edgeLabel p{background-color:hsl(180, 1.5873015873%, 28.3529411765%);}#export-svg .edgeLabel rect{opacity:0.5;background-color:hsl(180, 1.5873015873%, 28.3529411765%);fill:hsl(180, 1.5873015873%, 28.3529411765%);}#export-svg .labelBkg{background-color:rgba(71.1523809525, 73.4476190477, 73.4476190477, 0.5);}#export-svg .cluster rect{fill:hsl(20, 1.5873015873%, 12.3529411765%);stroke:hsl(20, 0%, 2.3529411765%);stroke-width:1px;}#export-svg .cluster text{fill:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg .cluster span{color:rgb(222.9999999999, 223.6666666666, 223.9999999999);}#export-svg div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(20, 1.5873015873%, 12.3529411765%);border:1px solid rgba(255, 255, 255, 0.25);border-radius:2px;pointer-events:none;z-index:100;}#export-svg .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#ccc;}#export-svg rect.text{fill:none;stroke-width:0;}#export-svg .icon-shape,#export-svg .image-shape{background-color:hsl(180, 1.5873015873%, 28.3529411765%);text-align:center;}#export-svg .icon-shape p,#export-svg .image-shape p{background-color:hsl(180, 1.5873015873%, 28.3529411765%);padding:2px;}#export-svg .icon-shape rect,#export-svg .image-shape rect{opacity:0.5;background-color:hsl(180, 1.5873015873%, 28.3529411765%);fill:hsl(180, 1.5873015873%, 28.3529411765%);}#export-svg .node .neo-node{stroke:#ccc;}#export-svg [data-look=\"neo\"].node rect,#export-svg [data-look=\"neo\"].cluster rect,#export-svg [data-look=\"neo\"].node polygon{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].node path{stroke:url(#export-svg-gradient);}#export-svg [data-look=\"neo\"].node .outer-path{filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].node .neo-line path{stroke:#ccc;filter:none;}#export-svg [data-look=\"neo\"].node circle{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].node circle .state-start{fill:#000000;}#export-svg [data-look=\"neo\"].statediagram-cluster rect{fill:#2a2020;stroke:url(#export-svg-gradient);stroke-width:1px;}#export-svg [data-look=\"neo\"].icon-shape .icon{fill:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg [data-look=\"neo\"].icon-shape .icon-neo path{stroke:url(#export-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,0.2));}#export-svg :root{--mermaid-font-family:\"trebuchet ms\",verdana,arial,sans-serif;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 10.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 7.75,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 0 L 11.5 7 L 0 14 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 11.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 4,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointStart"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    points: "0,7 11.5,14 11.5,0"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 10.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 11.5,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointEnd-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 0 0 L 11.5 7 L 0 14 z"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 11.5,
    markerUnits: "userSpaceOnUse",
    refY: 7,
    refX: 1,
    viewBox: "0 0 11.5 14",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-pointStart-margin"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    points: "0,7 11.5,14 11.5,0"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refX: 10.75,
    refY: 5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleEnd"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: 0,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleStart"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refX: 12.25,
    refY: 5,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleEnd-margin"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 14,
    markerWidth: 14,
    markerUnits: "userSpaceOnUse",
    refY: 5,
    refX: -2,
    viewBox: "0 0 10 10",
    className: "marker flowchart-v2",
    id: "export-svg_flowchart-v2-circleStart-margin"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    r: 5,
    cy: 5,
    cx: 5
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: 17.7,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossEnd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: -3.5,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossStart"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: 17.7,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossEnd-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    markerHeight: 12,
    markerWidth: 12,
    markerUnits: "userSpaceOnUse",
    refY: 7.5,
    refX: -3.5,
    viewBox: "0 0 15 15",
    className: "marker cross flowchart-v2",
    id: "export-svg_flowchart-v2-crossStart-margin"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    },
    className: "arrowMarkerPath",
    d: "M 1,1 L 14,14 M 1,14 L 14,1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clusters"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgePaths"
  }, /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTI0LCJ5Ijo3NH0seyJ4IjoxMjQsInkiOjk5fSx7IngiOjEyNCwieSI6MTI0fV0=",
    "data-id": "L_P10_0_P10_1_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P10_0_P10_1_0",
    d: "M124,74L124,99L124,120"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTI0LCJ5IjoxNjl9LHsieCI6MTI0LCJ5IjoxOTR9LHsieCI6MTI0LCJ5IjoyMTl9XQ==",
    "data-id": "L_P10_1_P10_2_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P10_1_P10_2_0",
    d: "M124,169L124,194L124,215"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTI0LCJ5IjoyODV9LHsieCI6MTI0LCJ5IjozMTB9LHsieCI6MTI0LCJ5IjozMzV9XQ==",
    "data-id": "L_P10_2_P10_3_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P10_2_P10_3_0",
    d: "M124,285L124,310L124,331"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTI0LCJ5IjozODB9LHsieCI6MTI0LCJ5Ijo0MDV9LHsieCI6MTI0LCJ5Ijo0MzB9XQ==",
    "data-id": "L_P10_3_P10_4_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P10_3_P10_4_0",
    d: "M124,380L124,405L124,426"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTI0LCJ5Ijo0OTZ9LHsieCI6MTI0LCJ5Ijo1MjF9LHsieCI6MTI0LCJ5Ijo1NDZ9XQ==",
    "data-id": "L_P10_4_P10_5_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P10_4_P10_5_0",
    d: "M124,496L124,521L124,542"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTI0LCJ5Ijo2MTJ9LHsieCI6MTI0LCJ5Ijo2Mzd9LHsieCI6MTI0LCJ5Ijo2NjJ9XQ==",
    "data-id": "L_P10_5_P10_6_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P10_5_P10_6_0",
    d: "M124,612L124,637L124,658"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTI0LCJ5Ijo3Mjh9LHsieCI6MTI0LCJ5Ijo3NTN9LHsieCI6MTI0LCJ5Ijo3Nzh9XQ==",
    "data-id": "L_P10_6_P10_7_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P10_6_P10_7_0",
    d: "M124,728L124,753L124,774"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTI0LCJ5Ijo4NDR9LHsieCI6MTI0LCJ5Ijo4Njl9LHsieCI6MTI0LCJ5Ijo4OTR9XQ==",
    "data-id": "L_P10_7_P10_8_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P10_7_P10_8_0",
    d: "M124,844L124,869L124,890"
  }), /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#export-svg_flowchart-v2-pointEnd-margin)",
    "data-points": "W3sieCI6MTI0LCJ5Ijo5Mzl9LHsieCI6MTI0LCJ5Ijo5NjR9LHsieCI6MTI0LCJ5Ijo5ODl9XQ==",
    "data-id": "L_P10_8_P10_End_0",
    "data-et": "edge",
    "data-edge": "true",
    style: {
      strokeDasharray: "0 0 37 9",
      strokeDashoffset: 0
    },
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    id: "L_P10_8_P10_End_0",
    d: "M124,939L124,964L124,985"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabels"
  }, /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P10_0_P10_1_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span || (_span = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P10_1_P10_2_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span2 || (_span2 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P10_2_P10_3_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span3 || (_span3 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P10_3_P10_4_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span4 || (_span4 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P10_4_P10_5_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span5 || (_span5 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P10_5_P10_6_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span6 || (_span6 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P10_6_P10_7_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span7 || (_span7 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P10_7_P10_8_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span8 || (_span8 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    "data-id": "L_P10_8_P10_End_0",
    className: "label"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    height: 0,
    width: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "labelBkg",
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span9 || (_span9 = /*#__PURE__*/React.createElement("span", {
    className: "edgeLabel"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 41)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_0",
    id: "flowchart-P10_0-0",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    "data-id": "P10_0",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span10 || (_span10 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "10.1 Initialize Conversation State"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 146.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_1",
    id: "flowchart-P10_1-1",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 209.1875,
    y: -22.5,
    x: -104.59375,
    "data-id": "P10_1",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-88.59375, -10.5)",
    style: {},
    className: "label"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 177.1875
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span11 || (_span11 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "10.2 Test Scenario: Greeting"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 252)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_2",
    id: "flowchart-P10_2-2",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    "data-id": "P10_2",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span12 || (_span12 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "10.3 Test Scenario: Recipe Discovery"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 357.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_3",
    id: "flowchart-P10_3-3",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 224.734375,
    y: -22.5,
    x: -112.3671875,
    "data-id": "P10_3",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-96.3671875, -10.5)",
    style: {},
    className: "label"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 192.734375
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span13 || (_span13 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "10.4 Test Scenario: Get Details"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 463)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_4",
    id: "flowchart-P10_4-4",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    "data-id": "P10_4",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span14 || (_span14 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "10.5 Test Scenario: Get Reviews"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 579)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_5",
    id: "flowchart-P10_5-5",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    "data-id": "P10_5",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span15 || (_span15 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "10.6 Test Scenario: Nutrition Analysis &amp; Visualization"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 695)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_6",
    id: "flowchart-P10_6-6",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    "data-id": "P10_6",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span16 || (_span16 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "10.7 Test Scenario: Customization"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 811)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_7",
    id: "flowchart-P10_7-7",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 66,
    width: 232,
    y: -33,
    x: -116,
    "data-id": "P10_7",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, -21)",
    style: {},
    className: "label"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 42,
    width: 200
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table",
      whiteSpace: "break-spaces",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center",
      width: 200
    }
  }, _span17 || (_span17 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "10.8 Test Scenario: Grounding (General Q)"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 916.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_8",
    id: "flowchart-P10_8-8",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 220.296875,
    y: -22.5,
    x: -110.1484375,
    "data-id": "P10_8",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-94.1484375, -10.5)",
    style: {},
    className: "label"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 188.296875
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span18 || (_span18 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "Final Message History Review"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124, 1011.5)",
    "data-look": "neo",
    "data-et": "node",
    "data-node": "true",
    "data-id": "P10_End",
    id: "flowchart-P10_End-9",
    className: "node default"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#gradient)",
    height: 45,
    width: 169.75,
    y: -22.5,
    x: -84.875,
    "data-id": "P10_End",
    style: {},
    className: "basic label-container"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.875, -10.5)",
    style: {},
    className: "label"
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("foreignObject", {
    height: 21,
    width: 137.75
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "table-cell",
      whiteSpace: "normal",
      lineHeight: 1.5,
      maxWidth: 200,
      textAlign: "center"
    }
  }, _span19 || (_span19 = /*#__PURE__*/React.createElement("span", {
    className: "nodeLabel"
  }, /*#__PURE__*/React.createElement("p", null, "End of Notebook Flow")))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: "130%",
    height: "130%",
    id: "drop-shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    floodColor: "#FFFFFF",
    floodOpacity: 0.06,
    stdDeviation: 0,
    dy: 4,
    dx: 4
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    width: "150%",
    height: "150%",
    id: "drop-shadow-small"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    floodColor: "#FFFFFF",
    floodOpacity: 0.06,
    stdDeviation: 0,
    dy: 2,
    dx: 2
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    y2: "0%",
    x2: "100%",
    y1: "0%",
    x1: "0%",
    gradientUnits: "objectBoundingBox",
    id: "export-svg-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#0042eb",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#eb0042",
    offset: "100%"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase9ConversationFlow);
export default __webpack_public_path__ + "static/media/phase9_conversation_flow.2438976186903a9e5199c35e6f6f023c.svg";
export { ForwardRef as ReactComponent };